export default {
  // 公司名称
  COMPANY_NAME: `原点参数`,
  // 当前版本号
  version: 'v1',
  // 问答版本号
  askVersion: 'v2',
  // 每次最大并发数-章节
  maxConcurrent: 10,
  // 表单名称对应
  FORM_NAME: {
    year: '年份', // 时间
    company: '公司名称', // 公司
    industry: '产业名称',
  },
}
